import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@/Components/Button/Button';
import { observer } from 'mobx-react-lite';
import { Title, Text } from '../../PreferencesComponents/Content';
import PreferencesGroup from '../../PreferencesComponents/PreferencesGroup';
import PreferencesSegment from '../../PreferencesComponents/PreferencesSegment';
import { useApplication } from '@/Components/ApplicationProvider';
import { c } from 'ttag';
const ClearSessionDataView = () => {
    const application = useApplication();
    return (_jsx(PreferencesGroup, { children: _jsxs(PreferencesSegment, { children: [_jsx(Title, { children: c('B1.Account.Session.Title').t `Clear workspace` }), _jsx(Text, { className: "mb-3", children: c('B1.Account.Session.Info')
                        .t `Remove all data related to the current workspace from the application.` }), _jsx(Button, { colorStyle: "danger", label: c('B1.Account.Session.Action').t `Clear workspace`, onClick: () => {
                        application.accountMenuController.setSigningOut(true);
                    } })] }) }));
};
export default observer(ClearSessionDataView);
